export default __webpack_public_path__ + "static/media/button_icon_03.0a39322b.svg";